<template>
  <el-dialog
    :visible.sync="visible"
    width="400px"
    top="270px"
    :close-on-click-modal="false"
    :append-to-body="true"
    :show-close="false"
    custom-class="digits-dialog"
  >
    <div slot="title" class="title">数字读音选择</div>
    <div class="digits-options">
      <el-radio-group v-model="selectedType">
        <el-radio 
          v-for="(type, key) in DIGIT_TYPES"
          :key="key"
          :label="type.value"
        >
          {{ type.label }}
        </el-radio>
      </el-radio-group>
    </div>
    <div slot="footer" class="btn-container">
      <el-button class="btn btn-primary" type="primary" @click="handleConfirm">确定</el-button>
      <el-button class="btn" @click="visible = false">取消</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { DIGIT_TYPES } from '../../../constants/ssml'
import { Dialog, RadioGroup, Radio, Button } from 'element-ui'

export default {
  name: 'DigitsPlugin',

  components: {
    'el-dialog': Dialog,
    'el-radio-group': RadioGroup,
    'el-radio': Radio,
    'el-button': Button
  },

  data() {
    return {
      visible: false,
      selectedType: 'digits',
      DIGIT_TYPES,
      savedRange: null
    }
  },

  methods: {
    show(range) {
      this.visible = true
      this.savedRange = range
      this.selectedType = 'digits'
    },

    handleConfirm() {
      if (!this.savedRange) return

      this.$emit('confirm', {
        tag: 'say-as',
        attrs: {
          'interpret-as': this.selectedType
        },
        range: this.savedRange
      })
      this.visible = false
    }
  }
}
</script>

<style lang="less" scoped>
.digits-options .el-radio-group {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-column-gap: 30px;
  grid-row-gap: 18px;
  
  /deep/.el-radio__input.is-checked .el-radio__inner {
    border-color: #41B48C;
    background:  #41B48C;
  }

  /deep/.el-radio__input+.el-radio__label {
    color: #666666;
    font-family: PingFang-SC, PingFang-SC;
    font-weight: 500;
    font-size: 14px;
  }
}
.btn-container {
  display: flex;
  justify-content: flex-end;
  margin-top: 2px;

  .btn {
    width: 65px;
    height: 32px;
    background: #B9C3C3;
    border-radius: 4px;
    font-family: PingFang-SC, PingFang-SC;
    font-size: 14px;
    color: #FFFFFF;
    padding: 0;
    border: none;
    outline: none;
  }

  .btn-primary {
    background: #41B48C;
  }
}
</style>
<style lang="less">
.digits-dialog {
  background: #FFFFFF;
  box-shadow: 0px 4px 12px 0px rgba(0,0,0,0.15) !important;
  border-radius: 4px !important;

  .el-dialog__header {
    padding: 32px 0 20px 32px;
  }

  .title {
    font-family: PingFang-SC, PingFang-SC;
    font-weight: bold;
    font-size: 16px;
    color: rgba(50,59,75,0.85);
    line-height: 24px;
    text-align: left;
    font-style: normal;
  }

  .el-dialog__body {
    padding: 0 32px;
  }

  .el-dialog__footer {
    padding: 20px 32px 24px 32px;
  }
}
</style>